import React from 'react';
import { motion } from 'framer-motion';

const SectionTitle = ({ children }) => {
  return (
    <motion.h1
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="text-3xl sm:text-5xl text-center font-light text-black pt-5 font-roboto mt-6 mb-6 p-4 w-full"
    >
      {children}
    </motion.h1>
  );
};

export default SectionTitle;